export enum CallType {
  Incoming = 'Incoming',
  Outgoing = 'Outgoing',
  Internal = 'Internal',
}
